import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import {Link} from 'react-router-dom'
import { AppBar, Toolbar, Grid, Box,  } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import logo from '../assets/invlogo.svg'

const useStyles = makeStyles({
  list: {
    width: 230,
  },
  fullList: {
    width: 'auto',
  },
  color: {
    backgroundColor: '#091a2d'  ,
color: 'white'    
},
reslogo: {
  height: '35px',
  paddingTop: '12px'
   
},
reslink: {
    textDecoration: 'none',
    color: '#091a2d',
    fontWeight: 'bold',
    fontSize: '18px',
},
reslink2: {
    textDecoration: 'none',
    color: '#213C54',
    fontSize: '18px',
},

});

export default function TemporaryDrawer() {
  const classes = useStyles();
  const [state, setState] = React.useState({    
    left: false,    
  });

  const toggleDrawer = (anchor, open) => event => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const list = anchor => (
    <div className={clsx(classes.list, {
        [classes.fullList]: anchor === 'top' || anchor === 'bottom',
      })}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List>                      
               {/*<ListItem key = {1} button divider>
             <Link to="/design&develop" className={classes.reslink}>Design & Develop</Link></ListItem>
               <ListItem key = {2} button divider>
               <Link to="/manufacture" className={classes.reslink}>Manufacture</Link></ListItem>
               <ListItem key = {3} button divider>
               <Link to="/distribute" className={classes.reslink}>Distribute</Link></ListItem>
               <ListItem key = {4} button divider>
               <Link to="/ourbrands" className={classes.reslink}>Our Brands</Link></ListItem>
               <ListItem key = {4} button divider></ListItem> */}
               <ListItem key = {5} button divider> 
               <Link to="/" className={classes.reslink2}>Home</Link> 
               </ListItem>  
               <a href="/#capabilities" className={classes.reslink2}>
               <ListItem key = {6} button divider>
               Capabilities </ListItem></a> 
               <ListItem key = {5} button divider> 
               <Link to="/quality" className={classes.reslink2}>Quality</Link></ListItem> 
           
                <a href="/#contact" className={classes.reslink2}>
               <ListItem key = {6} button divider>
               Contact </ListItem></a>
               <a href="/#about" className={classes.reslink2}>
               <ListItem key = {7} button divider>
              About</ListItem> </a>
      </List>
    </div>
  );

  return (
    <div>             
        <Box	display={{ xs: 'block', md: 'none', sm: 'block', lg: 'none' }} >
      {['left'].map(anchor => (
        <React.Fragment key={anchor}>
            <AppBar  className={classes.color} >        
          <Toolbar >
            <Grid container direction = "row" justify = "space-between"  >            
              <MenuIcon style={{fontSize:'30px',     paddingTop: '11px'}} onClick={toggleDrawer(anchor, true)}>{anchor}/></MenuIcon>          
          <Drawer anchor={anchor} open={state[anchor]} onClose={toggleDrawer(anchor, false)}>
            {list(anchor)}
          </Drawer>
          <Link to="/"> 
          <img src={logo} className={classes.reslogo} alt=""/></Link>
          </Grid>
          </Toolbar>
        </AppBar>
        <br/><br/>
        </React.Fragment>
      ))}
      </Box>
    </div>
  );
}